import React from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import kiraLogoColor from 'assets/kiraLogoColor.png';
import { API_URL } from 'config/app.endpoints';
import { t } from 'locales/i18n';
import animation from 'pages/NotFound/animation.module.scss';

const NotFound = () => {
  const particles = Array.from(Array(18).keys());

  const buttonLinkClassName = twMerge(
    'prose-button-sm',
    'bg-kira-blue-800',
    'hover:bg-kira-blue-900',
    'py-2',
    'px-4',
    'rounded-md',
    'text-white',
    'block',
    'transition'
  );

  return (
    <div className="h-screen">
      <div className="fixed z-10 flex h-full flex-col">
        <div className="p-4">
          <Link to={API_URL}>
            <img src={kiraLogoColor} alt="Kira Talent" className="w-32" />
          </Link>
        </div>
        <div className="flex flex-1 items-center">
          <div className="container mx-auto px-20">
            <h2 className="prose-display-1 text-kira-slate-900">
              {t('Uh oh!')}
            </h2>
            <p className="prose-body-xlg-reg max-w-[450px]">
              {t(
                'The page you’re looking for is either broken or doesn’t exist.'
              )}
            </p>
            <div className="flex pt-4">
              <Link to={API_URL} className={buttonLinkClassName}>
                {t('Go Home')}
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="relative z-0">
        {particles.map(() => (
          <div className={animation.particle} />
        ))}
      </div>
    </div>
  );
};

export default NotFound;
